import { swRequest, showToast } from "@sourcewhale/core";
import { caseInsensitiveSort, getUser, urlParams, wrapTooltip } from "../utils";
export const selectedItems = (table) =>
  $(`#${table}`).DataTable().rows({ selected: true }).data().toArray();

export const attachTableSelectHandlers = (
  tableName,
  currentPage = true,
  onChangeSelectCallback = null,
) => {
  const table = $(`#${tableName}`).DataTable();
  const selector = `#${tableName}_wrapper .dt-select-all-checkbox`;

  const onTableChangeSelect = () => {
    if (!selectedItems(tableName).length) $(selector).prop("checked", false);
    if (onChangeSelectCallback) onChangeSelectCallback();
  };
  table.on("select", onTableChangeSelect);
  table.on("deselect", onTableChangeSelect);
  table.on("page.dt", onTableChangeSelect);
  table.on("length", onTableChangeSelect);

  $(selector).change((e) => {
    const opts = { search: "applied" };
    if (currentPage) opts.page = "current";
    const rows = table.rows(opts);
    if ($(e.target).is(":checked")) rows.select();
    else rows.deselect();
  });

  const clearSelectAllCheckbox = () => {
    $(selector).prop("checked", false);
  };
  table.on("page.dt", clearSelectAllCheckbox);
  table.on("length", clearSelectAllCheckbox);
};

export const addSelector = (class_, id, opts, tableId, options = {}) => {
  const multiple = options.multi ? "multiple" : "";
  const actionsBox = options.actionsBox ? "true" : "false";
  const noneSelectedText = options.noneSelectedText || "Nothing selected";
  const countSelectedText = options.countSelectedText || "";
  const selectedTextFormat = options.countSelectedText ? "count" : "values";
  const dropdownAlignRight = options.dropdownAlignRight ? "true" : "auto";

  $(`.${class_}`).append(
    `<select
        id="${id}"
        class="selectpicker"
        ${multiple}
        data-actions-box="${actionsBox}"
        data-size="10"
        data-none-selected-text="${noneSelectedText}"
        data-count-selected-text="${countSelectedText}"
        data-selected-text-format="${selectedTextFormat}"
        data-dropdown-align-right="${dropdownAlignRight}"
        data-live-search="${opts.length > 10}"
        ></select>`,
  );

  const selector = $(`#${id}`);

  selector.append(opts.map((opt) => $("<option>", opt)));

  selector.selectpicker("refresh");

  const onChangeStandard = () => {
    $(`#${tableId}`).DataTable().draw();
  };
  if (options.onChange !== 0)
    selector.change(options.onChange || onChangeStandard);

  if (options.selectSelf || options.selectedUserId) selector.trigger("change");
};

export const addTableCampaignSelector = (data) => {
  const { tableId, options = {}, campaignData } = data;
  const renderCampaignSelector = (res) => {
    const campaigns = res.reduce((ret, campaign) => {
      ret[campaign.campaignName] = campaign.campaignId;
      return ret;
    }, {});

    const opts = [];

    if (!options.multi) {
      opts.push({
        value: "",
        "data-content":
          '<i class="fa-brands fa-telegram mr-2"></i>&nbsp;All Campaigns',
      });
    }

    if (options.includeNone) {
      opts.push({
        value: "none",
        "data-content":
          '<i class="fa-solid fa-circle-xmark mr-2"></i>&nbsp;No Campaign',
      });
    }

    caseInsensitiveSort(Object.keys(campaigns)).forEach((campaign) => {
      opts.push({
        value: campaigns[campaign],
        "data-content": `<i class="fa-brands fa-telegram mr-2"></i>&nbsp;${campaign}`,
      });
    });

    addSelector("campaign-selector", "campaignSelector", opts, tableId, {
      multi: options.multi,
      noneSelectedText: options.noneSelectedText,
      onChange: options.onChange,
      countSelectedText: "{0} campaigns selected",
      actionsBox: options.actionsBox,
    });

    if (urlParams.get("campaign_id")) {
      $("#campaignSelector").selectpicker("val", urlParams.get("campaign_id"));
      $(`#${tableId}`).DataTable().draw();
    }

    if (options.callback) options.callback(res);
    if (options.actionsBox)
      $(".campaign-selector .dropdown-menu .bs-deselect-all").text("Clear");
  };
  if (campaignData) renderCampaignSelector(campaignData);
  else
    swRequest({
      path: "/api/campaigns/get_open",
      params: {
        currentUserOnly: options.currentUserOnly,
        openOnly: options.openOnly,
      },
      method: "GET",
    }).then((res) => renderCampaignSelector(res));
};

export const addTableProjectSelector = (tableId, options = {}) => {
  swRequest({
    path: "/api/projects/get_all",
    method: "GET",
  }).then((res) => {
    const projects = res.reduce((ret, project) => {
      ret[project.projectName] = project.projectId;
      return ret;
    }, {});

    const opts = [];

    if (!options.multi) {
      opts.push({
        value: "",
        "data-content": "Projects",
      });
    }

    if (options.includeNone) {
      opts.push({
        value: "none",
        "data-content":
          '<i class="fa-solid fa-circle-xmark mr-2"></i>&nbsp;No Project',
      });
    }

    caseInsensitiveSort(Object.keys(projects)).forEach((project) => {
      opts.push({
        value: projects[project],
        "data-content": `<i class="fa-brands fa-telegram mr-2"></i>&nbsp;${project}`,
      });
    });

    addSelector("project-selector", "projectSelector", opts, tableId, {
      multi: options.multi,
      noneSelectedText: options.noneSelectedText,
      onChange: options.onChange,
      countSelectedText: "{0} projects selected",
      actionsBox: options.actionsBox,
    });

    if (options.actionsBox) {
      $(".project-selector .dropdown-menu .bs-deselect-all").text("Clear");
    }

    if (options.disabled) {
      $(".project-selector button").prop("disabled", true);
      $("#projectSelector").selectpicker("refresh");
    }
  });
};

const toggleFilter = () => {
  $("#searchFilters").toggleClass("extended");
  $(".search-filter-button").toggleClass("active");
  $(".search-filter-button .fa-filter").toggleClass("fa-regular fa-solid");
};

export const createUserOpt = (item, key, multi = false) => {
  const style = item.status === "deleted" ? "opacity: 0.5;" : "";
  const value = item.value || item.userIds.join(",");

  let content = `
    <div style="${style}">
      <i class="fa-regular fa-circle-user fa-fw mr-2"></i>&nbsp;${key}
    <div>
  `;
  if (multi) {
    const domain = item.email.split("@")[1];
    content += `<small class="ml-1 text-muted">${domain}</small>`;
  }
  return { value, "data-content": content };
};

export const addTableUserSelector = (tableId, kind, title, options = {}) => {
  const includeAll = options.includeAll === undefined || options.includeAll;
  const selectSelf = options.selectSelf !== undefined && options.selectSelf;
  const selectedUserId = options.selectedUserId || null;
  const useEmails = !!options.useEmails;

  swRequest({
    path: "/api/users/get_all",
    params: { applyAlias: !useEmails, includeDeleted: options.includeDeleted },
    method: "GET",
  }).then((res) => {
    const team = res.reduce((ret, user) => {
      if (useEmails) ret[user.email] = [user];
      else if (ret[user.name]) {
        ret[user.name].push(user);
      } else {
        ret[user.name] = [user];
      }
      return ret;
    }, {});

    const opts = [];

    if (includeAll) {
      opts.push({
        selected: true,
        value: "",
        "data-content": `<i class="fa-regular fa-user-group fa-fw mr-2"></i>&nbsp;All ${title}s`,
      });
    }

    [false, true].forEach((addDeleted) => {
      caseInsensitiveSort(Object.keys(team)).forEach((key) => {
        const multi = team[key].length > 1;

        team[key].forEach((item) => {
          const isDeleted = item.status === "deleted";
          if (addDeleted !== isDeleted) return;

          const opt = createUserOpt(item, key, multi);

          if (opt.value.includes(getUser().userId)) {
            if (selectSelf) opt.selected = true;
          }
          if (selectedUserId && opt.value.includes(selectedUserId)) {
            opt.selected = true;
          }
          opts.push(opt);
        });
      });
    });

    addSelector(`${kind}-selector`, `${kind}Selector`, opts, tableId, options);

    if (options.useURLParams) {
      let filtersApplied = false;

      if (urlParams.get("sourcers")) {
        const sourcerUserIds = urlParams.get("sourcers").split("|") || [];
        $("#sourcerSelector").selectpicker("val", sourcerUserIds);
        filtersApplied = true;
      }
      if (urlParams.get("campaignType")) {
        const campaignType = urlParams.get("campaignType");
        $("#filterByCampaignType").selectpicker("val", campaignType);
        filtersApplied = true;
      }

      if (filtersApplied) {
        toggleFilter();
        $(`#${tableId}`).DataTable().draw();
      }
    }
    if (options.callback) options.callback(team);
  });
};

export const addSearchFilter = () => {
  if (!$(".search-filter-button .fa-filter").length) {
    $(".search-filter-button").html(
      '<span><i class="fa-regular fa-filter"></i></span>',
    );

    const filterBtn = $(".search-filter-button")[0];
    if (filterBtn) {
      $(".search-filter-button").replaceWith(
        wrapTooltip(filterBtn.outerHTML, "Filter", "bottom", "h-100"),
      );
    }

    $(document).on("click", ".search-filter-button", () => {
      toggleFilter();
    });
  }
};

export const onTableAjaxFail = (url) => (err) => {
  if (err.status === 401) {
    localStorage.removeItem("provider");
    localStorage.removeItem("clarity");
    window.location.replace(
      `/signin?redirect=${window.location.pathname}${window.location.search}`,
    );
  } else if (err.status === 400) {
    showToast({
      title: "Error 400",
      subtitle: err.responseJSON,
      type: "danger",
    });
  } else {
    showToast({
      title: "Unable to load table",
      subtitle: "Please try again or contact support if the issue persists",
      type: "danger",
    });
    if (err.status !== 0) console.error(url, err.status);
  }
};

export const addStepsIndicator = (
  events,
  type,
  currentIndex = -1,
  total = 0,
) => {
  events = events || [];

  if (currentIndex === -1)
    currentIndex = events.findLastIndex((x) => x.isCurrent);

  total = total || events.length;

  if (currentIndex === -1 || total === 0) return "";

  // sorts by string value
  if (type === "sort") return (currentIndex + currentIndex / total) / 100;

  const ret = `<div class="steps"><span>${
    currentIndex + 1
  }</span>/${total}</div>`;

  if (!events.length) return ret;

  const steps = events
    .map((event) =>
      event.isCurrent
        ? `<b style='opacity:1 !important'><li>${event.name}</li></b>`
        : `<li style='opacity:0.5 !important'>${event.name}</li>`,
    )
    .join("");
  return wrapTooltip(
    ret,
    `<ol style="text-align: left; margin: 1rem 0.25rem; padding: 0rem 0.5rem 0rem 2rem">${steps}</ol>`,
  );
};

export const renderPercent = (prop, redLimit, greenLimit) => {
  if (prop === undefined) return "";

  const percent = Math.min(Math.ceil(prop * 100), 100);

  const over50 = percent > 50 ? "over50" : "";
  const underRed = percent < redLimit ? "red-circle-progress" : "";
  const overGreen = percent > greenLimit ? "green-circle-progress" : "";
  const size = percent === 100 ? "font-size: 0.5rem" : "";

  return `
      <div
        class="d-inline-flex align-items-center progress-circle p${percent} ${over50} ${underRed} ${overGreen}"
        style="vertical-align: middle">
        <span style="${size}">${percent}%</span>
        <div class="left-half-clipper ${overGreen}">
          <div class="first50-bar"></div>
          <div class="value-bar"></div>
        </div>
      </div>`;
};
